<template>
  <div class="automated-email-dashboard-ui">
    <div class="automated-email-dashboard-ui__header">
      <VHeading :level="4">Dashboard</VHeading>
      <div class="automated-email-dashboard-ui__period-dropdown">
        <VDropdown
          :model-value="period"
          :options="DASHBOARD_PERIOD_OPTIONS"
          @update:model-value="changePeriod"
        />
      </div>
    </div>

    <div class="automated-email-dashboard-ui__cards">
      <div class="automated-email-dashboard-ui__card">
        <div class="automated-email-dashboard-ui__card-icon">
          <VCircleIcon :src="team" />
        </div>
        <span class="automated-email-dashboard-ui__card-label">Contacts monitored</span>
        <span class="automated-email-dashboard-ui__card-value">{{ contactsMonitored }}</span>
        <span class="automated-email-dashboard-ui__card-description">
          Unique contacts in the pipeline
        </span>
      </div>

      <div class="automated-email-dashboard-ui__card">
        <div class="automated-email-dashboard-ui__card-icon">
          <VCircleIcon :src="mail" />
        </div>
        <span class="automated-email-dashboard-ui__card-label">
          Emails Sent ({{ period }} days)
        </span>
        <span class="automated-email-dashboard-ui__card-value">{{ emailsSent }}</span>
        <span class="automated-email-dashboard-ui__card-description">Total emails delivered</span>
      </div>

      <div class="automated-email-dashboard-ui__card">
        <div class="automated-email-dashboard-ui__card-icon">
          <VCircleIcon :src="calendar" />
        </div>
        <span class="automated-email-dashboard-ui__card-label"
          >Outbox Pending ({{ period }} days)</span
        >
        <span class="automated-email-dashboard-ui__card-value">{{ outboxPending }}</span>
        <span class="automated-email-dashboard-ui__card-description">
          Emails awaiting your review today
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  // Config
  import { DASHBOARD_PERIOD_OPTIONS } from '~/modules/opportunities/automated-email/dashboard/config';

  // Composables
  import { useDashboard } from '~/modules/opportunities/automated-email/dashboard/composables/use-dashboard';

  // Components
  import VHeading from '~/misc/v-heading/VHeading.vue';
  import VDropdown from '~/misc/v-dropdown';
  import VCircleIcon from '~/misc/v-circle-icon/VCircleIcon.vue';

  // Assets
  import team from '~/assets/images/icons/team.svg';
  import mail from '~/assets/images/icons/mail.svg';
  import calendar from '~/assets/images/icons/calendar.svg';

  const {
    patchId,
    saleType,
    period,
    contactsMonitored,
    emailsSent,
    outboxPending,
    fetchDashboard,
    changePeriod,
  } = useDashboard();

  watch(
    [patchId, saleType],
    ([nextPatchId, nextSaleType], [previousPatchId, previousSaleType]) => {
      if (
        nextPatchId === undefined ||
        (nextPatchId === previousPatchId && nextSaleType === previousSaleType)
      ) {
        return;
      }

      fetchDashboard().catch(() => undefined);
    }
  );

  onMounted(() => {
    if (patchId.value !== undefined) {
      fetchDashboard();
    }
  });

  onActivated(() => {
    if (patchId.value !== undefined) {
      fetchDashboard();
    }
  });
</script>
